module.exports = require("prismjs/components/prism-typescript.js");